<template>
    <div>
        <preloader v-show="$store.state.preloader"></preloader>
        <vueadmin_header></vueadmin_header>
        <div class="wrapper row-offcanvas">
            <left_side :showBigMenu="$store.state.layout.left_open"></left_side>
            <right_side>
                <router-view :key="$route.path"></router-view>
            </right_side>
        </div>
    </div>
</template>
<style lang="scss" src="../sass/custom.scss"></style>
<script>
import preloader from "./components/layouts/preloader/preloader.vue";
import right_side from "./components/layouts/right-side.vue";
import left_side from "./components/layouts/left-side/default/left-side.vue";
import vueadmin_header from "./components/layouts/header/fixed-header.vue";

export default {
    name: 'layout',
    components: {
        preloader,
        vueadmin_header,
        left_side,
        right_side,
    },
    data() {
        return {
            showtopbtn: false
        }
    },
    mounted() {
        if (window.innerWidth <= 992) {
            this.$store.commit('LEFT_MENU', "close");
        }
        this.$store.commit('LEFT_MENU', "init")
    }
}
</script>
<style lang="scss" scoped>
.wrapper:before,
.wrapper:after {
    display: table;
    content: " ";
}
.wrapper:after {
    clear: both;
}
.wrapper {
    display: table;
    overflow-x: hidden;
    width: 100%;
    max-width: 100%;
    table-layout: fixed
}
.right-aside,
.left-aside {
    padding: 0;
    display: table-cell;
    vertical-align: top;
}
.right-aside{
    background-color: #ebf2f6 !important;
}
@media (max-width: 992px) {
    .wrapper > .right-aside {
        width: 100vw;
        min-width: 100vw;
    }
}
</style>
